var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFF614"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 24.5C31.5 23.12 32.62 22 34 22V21C34 17 33 16 29 16H19C15 16 14 17 14 21V21.5C15.38 21.5 16.5 22.62 16.5 24C16.5 25.38 15.38 26.5 14 26.5V27C14 31 15 32 19 32H29C33 32 34 31 34 27C32.62 27 31.5 25.88 31.5 24.5Z",
    stroke: "#1A1528",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L22 32",
    stroke: "#1A1528",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetTickets);
export default __webpack_public_path__ + "static/media/get-tickets.7fdcb4236984bafc053bfc0174923cdc.svg";
export { ForwardRef as ReactComponent };